import type { FaqItem } from "@/components/shared/FAQ";
import type { HomeContent } from "../types";

export const ID_FAQS: FaqItem[] = [
  {
    question: "Bisa batalkan paket kapan saja?",
    answer:
      "Bisa. Kamu bisa membatalkan paket kapan saja lewat pengaturan. Paket tetap aktif sampai akhir siklus tagihan.",
  },
  {
    question: "Apa itu kredit workflow?",
    answer:
      "Satu kredit workflow sama dengan satu video yang dihasilkan AI Crayo. Ini termasuk AutoClip dan workflow lainnya.",
  },
  {
    question: "Bagaimana cara melihat pemakaian saya?",
    answer: "Kamu bisa melihat pemakaian di pengaturan. Klik foto profil di pojok kanan atas.",
  },
  {
    question: "Ada kebijakan refund?",
    answer:
      "Sayangnya kami tidak menyediakan refund. Kamu bisa membatalkan paket kapan saja dan paket tetap aktif sampai akhir siklus tagihan.",
  },
  {
    question: "Apa itu menit export?",
    answer:
      "Menit export adalah total durasi video yang bisa kamu hasilkan dengan Crayo. Misalnya, dengan 60 menit export kamu bisa membuat video 1 menit sebanyak 60 kali.",
  },
  {
    question: "Bisa monetisasi video yang dibuat dengan Crayo?",
    answer: "Bisa. Hak atas video yang kamu buat dengan Crayo sepenuhnya milik kamu.",
  },
  {
    question: "Bisa generate dalam bahasa lain?",
    answer:
      "Bisa. Kami mendukung hampir semua bahasa. Cukup tulis teks dalam bahasa yang kamu inginkan. Hubungi support kalau bahasa yang kamu butuhkan belum tersedia.",
  },
  {
    question: "Kredit yang tidak terpakai bisa dibawa ke bulan berikutnya?",
    answer:
      "Kredit langganan diisi ulang setiap bulan di semua jangka waktu paket, baik kamu bayar bulanan, triwulanan maupun tahunan, dan kredit yang tidak terpakai tidak terakumulasi. Kredit dari top-up sekali bayar terpisah dari jatah bulanan kamu.",
  },
];

export const ID_HOME: HomeContent = {
  seoTitle: "Crayo: Editor Video AI untuk Klip Viral",
  seoDescription:
    "Editor video AI untuk video pendek. Potong klip otomatis, subtitle otomatis, voiceover AI, dan lainnya. Video panjang jadi Shorts viral dalam sekejap.",
  heading: {
    prefix: "Tool",
    highlight: "Clipping #1",
    suffix: "Edit Video Viral dengan AI",
  },
  body: "Tool all-in-one untuk potong klip otomatis, voiceover AI, subtitle yang bikin betah nonton, dan lainnya.",
  mobileBody: "Platform all-in-one untuk editing.",
  faqs: ID_FAQS,
};
